import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { useAllEngagementSessionsByClient } from "~/lib/queries/sessionQuery";

import { UpcomingSessions } from "./-components/upcoming-sessions";
import { UserSessionHistory } from "./-components/user-session-history";

const sessionsSearchSchema = z.object({
  sessionId: z.string().optional(),
});

export const Route = createFileRoute("/_user/coaching/$engagementId/sessions")({
  staticData: { title: "Sessions" },
  validateSearch: sessionsSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { engagementId } = Route.useParams();

  const {
    data: sessionData,
    isLoading: sessionLoading,
    error: sessionError,
  } = useAllEngagementSessionsByClient(engagementId);

  return (
    <div className="flex w-full min-w-0 flex-1 flex-col space-y-6">
      <UpcomingSessions
        engagementId={engagementId}
        sessions={sessionData?.upcomingSessions}
        isLoading={sessionLoading}
        error={sessionError}
      />

      <UserSessionHistory engagementId={engagementId} />
    </div>
  );
}
